<template>
  <a-modal
      :title="title"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @cancel="$emit('close')"
      @ok="handleSubmit"
      destroyOnClose
  >
    <a-form
        :form="form"
        v-bind="formItemLayout"
        v-if="visible"
    >
      <!--<a-form-item label="上传图片">
          <a-upload
                  name="avatar"
                  list-type="picture-card"
                  :show-upload-list="false"
                  action=""
                  :before-upload="beforeUpload"
                  @change="handleChange"
                  :customRequest="customRequest"
          >
              <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
              <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" style="font-size:30px;color:#dcdcdc"/>
              </div>
          </a-upload>
          <span>大小不超过10M,格式为jpg</span>
      </a-form-item>-->
      <a-form-item label="科目名称">
        <a-input v-model="name" placeholder="请输入科目名称" />
      </a-form-item>
      <a-form-item label="科目代码">
        <a-input v-model="code" placeholder="请输入科目代码" />
      </a-form-item>
      <a-form-item label="展示状态">
        <a-switch :defaultChecked="show" @change="setShow()"/>
      </a-form-item>
      <hr>
      <a-form-item label="VIP原价">
        <a-input-number 
          v-model="vipPrice" 
          :min="0" 
          :precision="2" 
          style="width: 100%"
          placeholder="请输入VIP原价"
        />
      </a-form-item>
      <a-form-item label="划线价格">
        <a-input-number 
          v-model="strikethroughPrice" 
          :min="0" 
          :precision="2" 
          style="width: 100%"
          placeholder="请输入划线价格"
        />
      </a-form-item>
      <a-form-item label="已购人数">
        <a-input-number 
          v-model="purchasedCount" 
          :min="0" 
          :precision="0" 
          style="width: 100%"
          placeholder="请输入已购人数"
        />
      </a-form-item>
      <hr>
      <a-form-item label="单卷价格">
        <a-input-number 
          v-model="singlePaperPrice" 
          :min="0" 
          :precision="2" 
          style="width: 100%"
          placeholder="请输入单卷下载价格"
        />
      </a-form-item>
      <a-form-item label="整科价格">
        <a-input-number 
          v-model="wholePaperPrice" 
          :min="0" 
          :precision="2" 
          style="width: 100%"
          placeholder="请输入整科下载价格"
        />
      </a-form-item>
      <hr>
      <a-form-item label="考期选择">
        <div v-for="(exam, index) in examPeriods" :key="index" style="margin-bottom: 10px;">
          <a-row :gutter="8">
            <a-col :span="10">
              <a-select 
                v-model="exam.month" 
                placeholder="请选择月份" 
                style="width: 100%;"
                :disabled="!!exam.id"
              >
                <a-select-option 
                  v-for="m in getAvailableMonths(index)" 
                  :key="m.value" 
                  :value="m.value"
                >
                  {{ m.label }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="10">
              <a-select 
                v-model="exam.day" 
                placeholder="请选择日期" 
                style="width: 100%;"
              >
                <a-select-option value="sat_am">周六上午</a-select-option>
                <a-select-option value="sat_pm">周六下午</a-select-option>
                <a-select-option value="sun_am">周日上午</a-select-option>
                <a-select-option value="sun_pm">周日下午</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="4">
              <a-button 
                v-if="examPeriods.length > 1" 
                type="danger" 
                icon="minus" 
                @click="removeExamPeriod(index)"
              />
            </a-col>
          </a-row>
        </div>
        <a-button 
          v-if="examPeriods.length < 4" 
          type="primary" 
          icon="plus" 
          @click="addExamPeriod"
          style="margin-top: 10px;"
        >
          添加考期
        </a-button>
      </a-form-item>
      <!-- exam_time -->
      <!-- <a-form-item label="考试时间">
        <a-input 
          v-model="exam_time" 
          style="width: 100%"
          placeholder="输入考试时间 例如 10:00-11:00" />
      </a-form-item> -->
      
<!--      <a-form-item label="排序序号">-->
<!--        <a-input v-model="sortby" placeholder="从大到小 优先排序" />-->
<!--      </a-form-item>-->
      <a-form-item label="关联分类">
        <a-cascader class="csscsder" :value="cascader" :fieldNames="{ label: 'cname', value: 'id', children: 'son' }" :options="options" @change="onChange" placeholder="请选择关联分类" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getCate, uploadImg } from '@/libs/api'
import * as http from '@/libs/analysis'
export default {
  name: 'addOpencourse',
  props: [ 'visible', 'data' ],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  watch:{
    visible(val){
      if(val){

        if(this.data.length == 0){
          this.title = "新增科目"
          this.name = ''
          this.code = ''
          this.show = false
          this.vipPrice = 0
          this.strikethroughPrice = 0
          this.purchasedCount = 0
          this.singlePaperPrice = 0
          this.wholePaperPrice = 0
          // 初始化考期数组
          this.examPeriods = [{
            month: '',
            day: '',
            id: null
          }]
          this.exam_time = ''
          this.sortby = 0
          this.cascader = []
        }else{
          this.title = "编辑科目"
          this.name = this.data.name
          this.code = this.data.code
          this.show = this.data.show
          // 处理考期数据
          this.initExamPeriods()
          this.vipPrice = parseFloat(this.data.vip_price) || 0
          this.strikethroughPrice = parseFloat(this.data.strikethrough_price) || 0
          this.purchasedCount = parseInt(this.data.purchased_count) || 0
          this.singlePaperPrice = parseFloat(this.data.single_paper_price) || 0
          this.wholePaperPrice = parseFloat(this.data.whole_paper_price) || 0
          this.exam_time = this.data.exam_time
          this.sortby = this.data.sortby
          if(this.data.cascader && this.data.cascader.length>2){
            this.cascader = this.data.cascader.split(',').map(el => Number(el))
          }else{
            this.cascader = []
          }
        }
      }
    }
  },
  data(){
    return{
      confirmLoading: false,
      loading: false,
      title: '',
      name: '',
      show: false,
      vipPrice: 0,
      strikethroughPrice: 0,
      purchasedCount: 0,
      singlePaperPrice: 0,
      wholePaperPrice: 0,
      examPeriods: [{
        month: '',
        day: '',
        id: null
      }],
      sortby: '',
      cascader: [],
      cate_id: '',
      options: [],
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 },
      },
      url:'',
      exam_time: ''
    }
  },
  mounted(){
    this.GetCate()
  },
  methods:{
    // 初始化考期数据
    initExamPeriods() {
      // 检查是否有新的 exam_periods 数据结构
      if (this.data.exam_periods && Array.isArray(this.data.exam_periods)) {
        // 如果有考期数据，则使用现有数据
        this.examPeriods = this.data.exam_periods.map(item => ({
          month: item.month || '',
          day: item.day || '',
          id: item.id || null
        }))
      } 
      // 检查是否是 JSON 字符串格式的 exam_month
      else if (this.data.exam_month && typeof this.data.exam_month === 'string') {
        try {
          // 尝试解析 JSON 字符串
          const parsedExamMonth = JSON.parse(this.data.exam_month);
          if (Array.isArray(parsedExamMonth)) {
            this.examPeriods = parsedExamMonth.map(item => ({
              month: item.month || '',
              day: item.day || '',
              id: item.id || null
            }))
          } else {
            // 如果解析后不是数组，使用原始值
            this.examPeriods = [{
              month: this.data.exam_month || '',
              day: this.data.exam_day || '',
              id: null
            }]
          }
        } catch (e) {
          // 如果解析失败，回退到原始值
          this.examPeriods = [{
            month: this.data.exam_month || '',
            day: this.data.exam_day || '',
            id: null
          }]
        }
      } 
      // 兼容旧数据格式
      else if (this.data.exam_month || this.data.exam_day) {
        this.examPeriods = [{
          month: this.data.exam_month || '',
          day: this.data.exam_day || '',
          id: null
        }]
      } else {
        // 默认初始化
        this.examPeriods = [{
          month: '',
          day: '',
          id: null
        }]
      }
    },
    // 获取可用的月份选项（排除已被选择的月份）
    getAvailableMonths(currentIndex) {
      const allMonths = [
        { value: 'jan', label: '1月' },
        { value: 'apr', label: '4月' },
        { value: 'jul', label: '7月' },
        { value: 'oct', label: '10月' }
      ]
      
      // 获取已经被其他考期选择的月份
      const selectedMonths = this.examPeriods
        .filter((exam, index) => index !== currentIndex && exam.month)
        .map(exam => exam.month)
      
      // 返回未被选择的月份
      return allMonths.filter(month => !selectedMonths.includes(month.value))
    },
    // 添加新的考期
    addExamPeriod() {
      if (this.examPeriods.length < 4) {
        this.examPeriods.push({
          month: '',
          day: '',
          id: null
        })
      }
    },
    // 删除指定的考期
    removeExamPeriod(index) {
      if (this.examPeriods.length > 1) {
        this.examPeriods.splice(index, 1)
      }
    },
    onChange(id){
      this.cascader = id
      console.log(id)
      this.cate_id = this.cascader[this.cascader.length-1]
    },
    GetCate(){
      return new Promise((resolve,reject)=>{
        getCate().then(res=>{
          if(res.length){
            this.dealArr(res)
            this.options=res
          }
          resolve()
        },error=>{
          console.log(error)
          reject()
        })
      })
    },
    dealArr(data){
      data.forEach(el => {
        if(!el.son.length){
          delete el.son
        }
        if(el.son &&  el.son.length){
          this.dealArr(el.son)
        }
      })
    },
    setShow(e){
      this.show = !this.show;
    },
    handleSubmit(){
      this.confirmLoading = true

      if (this.examPeriods.length === 1 && 
          this.examPeriods[0].month === '' && 
          this.examPeriods[0].day === '') {
        this.examPeriods = []
      } else {
        const isValid = this.examPeriods.every(exam => 
          exam.month !== '' && exam.day !== ''
        )
        
        if (!isValid) {
          this.$message.error('请完善所有考期信息或删除不完整的考期')
          this.confirmLoading = false
          return
        }
      }
      
      if(this.data.length == 0){
        http.add_course_subject({
          name: this.name, 
          code: this.code,  
          cascader: this.cascader, 
          cate_id: this.cate_id, 
          show: this.show, 
          sortby: this.sortby,
          vip_price: this.vipPrice,
          strikethrough_price: this.strikethroughPrice,
          purchased_count: this.purchasedCount,
          single_paper_price: this.singlePaperPrice,
          whole_paper_price: this.wholePaperPrice,
          exam_periods: this.examPeriods,
          exam_time: this.exam_time,
        }).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }else{
        http.edit_course_subject({
          name: this.name, 
          code: this.code, 
          cascader: this.cascader, 
          cate_id: this.cate_id, 
          show: this.show, 
          sortby: this.sortby, 
          id: this.data.id,
          vip_price: this.vipPrice,
          strikethrough_price: this.strikethroughPrice,
          purchased_count: this.purchasedCount,
          single_paper_price: this.singlePaperPrice,
          whole_paper_price: this.wholePaperPrice,
          exam_periods: this.examPeriods,
          exam_time: this.exam_time,
        }).then(res=>{
          this.$emit('close')
          this.$emit('update')
          this.confirmLoading = false
        }).catch((error)=>{
          console.log(error)
          this.confirmLoading = false
        })
      }
    },
    beforeUpload(){

    },
    customRequest(data){
      let formData = new FormData()
      formData.append('file',data.file)
      uploadImg(formData).then(res=>{
        if(res){
          this.imageUrl=res.fileUrl
        }
      },error=>{
        console.log(error)
      })
    },
    handleChange(){

    }
  }
}
</script>